import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { sessionLogger } from '@chegg-ui/utils';
import { clickBaseEvent, viewBaseEvent } from '@chegg-me-components/utils';
import { CenterLinks, CenterLink, CenterLinkNewLabel, StyledTooltip, Divider, CenterDropdownLink, CenterLinksUL, DropdownUL, VisuallyHidden } from '../../styles';
import { // DigitalDataEvent,
NavType } from '../../types';
import { rioClient } from './../rio'; // TODO: this needs more work for https://chegg.atlassian.net/browse/CUI-631
// declare let digitalData: {
//   event: DigitalDataEvent | DigitalDataEvent[];
// };
// declare const _satellite: {
//   track: (event: string) => void;
// };
// type AdobeEventKey = 'event140' | 'event141' | 'event142' | 'event143';
// const adobeLogInfo: {
//   [key in AdobeEventKey]: {
//     eventName: string;
//     eventValue: {
//       elName: string;
//       elRegion: string;
//     };
//     eventID: string;
//     type: string;
//     timeStamp: Date;
//   };
// } = {
//   event140: {
//     eventName: 'Chegg homepage navigation',
//     eventValue: {
//       elName: 'Homepage Global Nav - Study Pack Selected',
//       elRegion: 'Homepage Global Nav',
//     },
//     eventID: 'event140',
//     type: 'link',
//     timeStamp: new Date(),
//   },
//   event141: {
//     eventName: 'Books dedicated navigation',
//     eventValue: {
//       elName: 'Books Dedicated Nav - Study Pack Selected',
//       elRegion: 'Books Dedicated Nav',
//     },
//     eventID: 'event141',
//     type: 'link',
//     timeStamp: new Date(),
//   },
//   event142: {
//     eventName: 'CS page navigation',
//     eventValue: {
//       elName: 'CS Dedicated Nav - Study Pack Selected',
//       elRegion: 'CS Dedicated Nav',
//     },
//     eventID: 'event142',
//     type: 'link',
//     timeStamp: new Date(),
//   },
//   event143: {
//     eventName: 'CS SERP navigation',
//     eventValue: {
//       elName: 'CS SERP Nav - Study Pack Selected',
//       elRegion: 'CS SERP Dedicated Nav',
//     },
//     eventID: 'event143',
//     type: 'link',
//     timeStamp: new Date(),
//   },
// };
// const adobeCspLog = (eventKey: AdobeEventKey): void => {
//   // header initializes digitalData if needed and errors without _satellite, so else case won't happen
//   /* istanbul ignore else */
//   if (typeof _satellite !== 'undefined' && typeof digitalData !== 'undefined') {
//     // we overwrite timestamp to ensure it's accurate to click time
//     digitalData.event = [{ ...adobeLogInfo[eventKey], timeStamp: new Date() }];
//     _satellite.track('event');
//   }
// };

var getDropDownRegion = function getDropDownRegion(nav, text) {
  var region_name = '';

  switch (nav) {
    case NavType.home:
      region_name = text;
      break;

    default:
      region_name = "".concat(nav, " nav header | ").concat(text);
      break;
  }

  return region_name;
};

var DesktopCenterNav = function DesktopCenterNav(_ref) {
  var navLinks = _ref.navLinks,
      navType = _ref.navType,
      envUrl = _ref.envUrl,
      pageTrackId = _ref.pageTrackId,
      activeSubLink = _ref.activeSubLink;
  return /*#__PURE__*/React.createElement(CenterLinks, {
    role: "navigation",
    "aria-label": "main"
  }, /*#__PURE__*/React.createElement(CenterLinksUL, null, navLinks.map(function (link, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: link.text
    }, navType === NavType.books && index > 1 && /*#__PURE__*/React.createElement(Divider, null), link.childLinks ? /*#__PURE__*/React.createElement(StyledTooltip, {
      position: "bottom",
      targetElement: /*#__PURE__*/React.createElement(CenterLink, {
        href: "".concat(envUrl).concat(link.href),
        isActive: activeSubLink ? activeSubLink === link.href : navType === link.href,
        "data-test": "header-".concat(link.loggingKey),
        onMouseEnter: function onMouseEnter() {
          /**
           * Rio logging for click on menu options
           * for different navtypes which
           * have child links/dropdown in thier menu links
           */
          rioClient.sendEvent(_objectSpread(_objectSpread({}, viewBaseEvent), {}, {
            data: {
              component_view: {
                component: {
                  name: link.text,
                  type: 'drop down',
                  region_name: navType === NavType.home ? 'header' : "".concat(navType, " menu header")
                },
                state: 'expanded'
              }
            }
          }));
        },
        onClick: function onClick() {
          /**
           * Rio logging for click on menu options
           * for different navtypes which
           * have child links/dropdown in thier menu links
           */
          rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
            data: {
              interaction: {
                type: 'select',
                element: {
                  name: 'nav header shortcut',
                  type: 'link',
                  region_name: navType === NavType.home ? 'nav header' : "".concat(navType, " nav header"),
                  value: link.text
                }
              }
            }
          }));
          sessionLogger.event(envUrl, pageTrackId, {
            navigation_click: link.loggingKey
          });
        },
        displayNewBadge: link.displayNewBadge
      }, (activeSubLink ? activeSubLink === link.href : navType === link.href) && /*#__PURE__*/React.createElement(VisuallyHidden, null, "Current Page: "), link.text, link.displayNewBadge && /*#__PURE__*/React.createElement(CenterLinkNewLabel, null, "NEW!"))
    }, /*#__PURE__*/React.createElement(DropdownUL, null, link.childLinks.map(function (childLink, childIndex) {
      return /*#__PURE__*/React.createElement("li", {
        key: childIndex
      }, /*#__PURE__*/React.createElement(CenterDropdownLink, {
        href: "".concat(envUrl).concat(childLink.href),
        "data-test": "header-".concat(childLink.loggingKey),
        onClick: function onClick() {
          /**
           * Rio logging for click on
           * child links or dropdown links
           */
          rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
            data: {
              interaction: {
                type: 'select',
                element: {
                  name: 'nav header menu item',
                  type: 'link',
                  region_name: getDropDownRegion(navType, link.text),
                  value: childLink.text
                }
              }
            }
          }));
          sessionLogger.event(envUrl, pageTrackId, {
            navigation_click: childLink.loggingKey
          }); // TODO: this needs more work for https://chegg.atlassian.net/browse/CUI-631
          // // this is here to recreate this logic
          // // https://bitbucket.cheggnet.com/projects/OC/repos/chegg-header/browse/src/js/header/c.global.header.navigation.js?at=refs%2Ftags%2FRELEASE_20200209_CHEGG-HEADER#369-403
          // // the study-pack link only renders in a dropdown like this when navType === books or home, so we don't need to check for study
          // if (childLink.href === 'study-pack') {
          //   if (navType === NavType.books) {
          //     sessionLogger.event(envUrl, pageTrackId, {
          //       books_dedicated_nav: 'clicked',
          //     });
          //     adobeCspLog('event141');
          //   } else if (navType === NavType.home) {
          //     sessionLogger.event(envUrl, pageTrackId, {
          //       home_global_nav: 'clicked',
          //     });
          //     adobeCspLog('event140');
          //   }
          // }
        }
      }, childLink.text));
    }))) : /*#__PURE__*/React.createElement(CenterLink, {
      href: "".concat(envUrl).concat(link.href),
      isActive: activeSubLink ? activeSubLink === link.href : navType === link.href,
      displayNewBadge: link.displayNewBadge,
      onClick: function onClick() {
        /**
         * Rio logging for click on menu options
         * for different navtypes which
         * don't have child links/dropdown in thier menu links
         */
        rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
          data: {
            interaction: {
              type: 'select',
              element: {
                name: 'nav header shortcut',
                type: 'link',

                /**
                 * All the menu options in home navytpe
                 * consist of child links so here there
                 * will be no case of home navtype here
                 */
                region_name: "".concat(navType, " nav header"),
                value: link.text
              }
            }
          }
        }));
        sessionLogger.event(envUrl, pageTrackId, {
          navigation_click: link.loggingKey
        }); // TODO: this needs more work for https://chegg.atlassian.net/browse/CUI-631
        // // this is here to recreate this logic
        // // https://bitbucket.cheggnet.com/projects/OC/repos/chegg-header/browse/src/js/header/c.global.header.navigation.js?at=refs%2Ftags%2FRELEASE_20200209_CHEGG-HEADER#369-387
        // // the study-pack link only renders outside a dropdown like this when navType === study, so we don't need to check navType here like above
        // if (link.href === 'study-pack') {
        //   if (window.location.pathname.indexOf('/search') !== -1) {
        //     sessionLogger.event(envUrl, pageTrackId, {
        //       cs_serp_nav: 'clicked',
        //     });
        //     adobeCspLog('event143');
        //   } else {
        //     sessionLogger.event(envUrl, pageTrackId, {
        //       cs_main_nav: 'clicked',
        //     });
        //     adobeCspLog('event142');
        //   }
        // }
      }
    }, (activeSubLink ? activeSubLink === link.href : navType === link.href) && /*#__PURE__*/React.createElement(VisuallyHidden, null, "Current Page: "), link.text, link.displayNewBadge && /*#__PURE__*/React.createElement(CenterLinkNewLabel, null, "NEW!")));
  })));
};

DesktopCenterNav.displayName = 'DesktopCenterNav';
export default DesktopCenterNav;